// extracted by mini-css-extract-plugin
export var brand = "static-page-nav-module--brand--k0QI-";
export var loginButton = "static-page-nav-module--login-button---dsDM";
export var menuToggle = "static-page-nav-module--menu-toggle--1ZlXt";
export var mobileMenu = "static-page-nav-module--mobile-menu--1ccFW";
export var mobileMenuOpen = "static-page-nav-module--mobile-menu-open--ZA7oN";
export var nav = "static-page-nav-module--nav---5Afh";
export var navLinks = "static-page-nav-module--nav-links--Wo9uL";